import script from "./SignModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SignModal.vue?vue&type=script&setup=true&lang=js"

import "./SignModal.vue?vue&type=style&index=0&id=ffd3aa50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffd3aa50"]])

export default __exports__